/**
 * @file src/helpers/browser/reloadDocument.ts
 * @exports reloadDocument
 * @summary Reloads the current document. Exists so callers can be tested: jsdom's `window.location` cannot be stubbed.
 */

export const reloadDocument = (): void => {
	window.location.reload();
};
